import { Modal } from "antd";
import { Assets } from "utils/Assets";
import UniversalDetail from "pages/universals/UniversalDetail";
import NoDataPage from "pages/nodata/NoDataPage";

const UniversalDetailModal = ({ openModal, setOpenModal, universalDetail }) => {
    console.log(universalDetail,'universalDetail')
    return (
        <>
            <Modal
                footer=''
                width={1200}
                open={openModal}
                onCancel={() => setOpenModal(false)}
                closeIcon={<img src={Assets.closeIcon} alt="" />}
                className="modal_content"
            >
                <div className="mt-4">
                    {universalDetail ?
                        <UniversalDetail universal={universalDetail} />
                        :
                        <NoDataPage text={`Universal Data Not Found`} />
                    }
                </div>
            </Modal>
        </>
    )
}

export default UniversalDetailModal;
